export const FRENCH_PHONE_NUMBER_REGEX = /^(?:\d{3}[-]?)(\d{3}[-])(\d{4})$/; // Test Regex online : https://regex101.com/r/URqjgE/1

export const FRENCH_SIRET_REGEX = /^(?:\d{3}\s?){3}\d{5}$/; // Test Regex online : https://regex101.com/r/0IuJb7/1

/* eslint-disable no-control-regex */
export const EMAIL_ADDRESS_REGEX =
  /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
/* eslint-enable no-control-regex */

export const FRENCH_CADASTRE_REGEX = /^[0-9]{8}[A-Z]{2}[0-9]{4}$/; // Test Regex online : https://regex101.com/r/MIrFY1/2
